import { Permission } from '~/types/Permission';

import { checkIsAdmin } from './checkIsAdmin';

export const canUseUsersPage: Permission = checkIsAdmin;
